import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { TerminalExtensions } from 'vscode/vscode/vs/platform/terminal/common/terminal';
import { ITerminalLogService } from 'vscode/vscode/vs/platform/terminal/common/terminal.service';
import { ITerminalProfileService, ITerminalProfileResolverService } from 'vscode/vscode/vs/workbench/contrib/terminal/common/terminal.service';
import { ITerminalService, ITerminalEditorService, ITerminalGroupService, ITerminalInstanceService, ITerminalConfigurationService } from 'vscode/vscode/vs/workbench/contrib/terminal/browser/terminal.service';
export { ITerminalInstanceService, ITerminalService } from 'vscode/vscode/vs/workbench/contrib/terminal/browser/terminal.service';
import { TerminalService } from './vscode/src/vs/workbench/contrib/terminal/browser/terminalService.js';
import { TerminalEditorService } from './vscode/src/vs/workbench/contrib/terminal/browser/terminalEditorService.js';
import { TerminalGroupService } from './vscode/src/vs/workbench/contrib/terminal/browser/terminalGroupService.js';
import { TerminalInstanceService } from './vscode/src/vs/workbench/contrib/terminal/browser/terminalInstanceService.js';
import { TerminalProfileService } from './vscode/src/vs/workbench/contrib/terminal/browser/terminalProfileService.js';
import { TerminalContributionService } from './vscode/src/vs/workbench/contrib/terminal/common/terminalExtensionPoints.js';
import { ITerminalContributionService } from 'vscode/vscode/vs/workbench/contrib/terminal/common/terminalExtensionPoints.service';
import { ITerminalLinkProviderService } from 'vscode/vscode/vs/workbench/contrib/terminalContrib/links/browser/links.service';
import { TerminalLinkProviderService } from './vscode/src/vs/workbench/contrib/terminalContrib/links/browser/terminalLinkProviderService.js';
import { ElectronTerminalProfileResolverService } from './vscode/src/vs/workbench/contrib/terminal/electron-sandbox/terminalProfileResolverService.js';
import { EnvironmentVariableService } from './vscode/src/vs/workbench/contrib/terminal/common/environmentVariableService.js';
import { IEnvironmentVariableService } from 'vscode/vscode/vs/workbench/contrib/terminal/common/environmentVariable.service';
import { ITerminalQuickFixService } from 'vscode/vscode/vs/workbench/contrib/terminalContrib/quickFix/browser/quickFix.service';
import { TerminalLogService } from './vscode/src/vs/platform/terminal/common/terminalLogService.js';
import { TerminalQuickFixService } from './vscode/src/vs/workbench/contrib/terminalContrib/quickFix/browser/terminalQuickFixService.js';
import { Event, Emitter } from 'vscode/vscode/vs/base/common/event';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { DeferredPromise } from 'vscode/vscode/vs/base/common/async';
import { EmbedderTerminalService } from './vscode/src/vs/workbench/services/terminal/common/embedderTerminalService.js';
import { IEmbedderTerminalService } from 'vscode/vscode/vs/workbench/services/terminal/common/embedderTerminalService.service';
import { TerminalConfigurationService } from './vscode/src/vs/workbench/contrib/terminal/browser/terminalConfigurationService.js';
import { unsupported } from './tools.js';
import './vscode/src/vs/workbench/contrib/terminal/browser/terminal.contribution.js';
import './vscode/src/vs/workbench/contrib/terminal/browser/terminalView.js';
import './vscode/src/vs/workbench/contrib/terminalContrib/accessibility/browser/terminal.accessibility.contribution.js';
import './vscode/src/vs/workbench/contrib/terminalContrib/developer/browser/terminal.developer.contribution.js';
import './vscode/src/vs/workbench/contrib/terminalContrib/environmentChanges/browser/terminal.environmentChanges.contribution.js';
import './vscode/src/vs/workbench/contrib/terminalContrib/find/browser/terminal.find.contribution.js';
import './vscode/src/vs/workbench/contrib/terminalContrib/chat/browser/terminal.chat.contribution.js';
import './vscode/src/vs/workbench/contrib/terminalContrib/highlight/browser/terminal.highlight.contribution.js';
import './vscode/src/vs/workbench/contrib/terminalContrib/links/browser/terminal.links.contribution.js';
import './vscode/src/vs/workbench/contrib/terminalContrib/zoom/browser/terminal.zoom.contribution.js';
import './vscode/src/vs/workbench/contrib/terminalContrib/stickyScroll/browser/terminal.stickyScroll.contribution.js';
import './vscode/src/vs/workbench/contrib/terminalContrib/quickFix/browser/terminal.quickFix.contribution.js';
import './vscode/src/vs/workbench/contrib/terminalContrib/typeAhead/browser/terminal.typeAhead.contribution.js';
import './vscode/src/vs/workbench/contrib/terminalContrib/suggest/browser/terminal.suggest.contribution.js';
import './vscode/src/vs/workbench/contrib/externalTerminal/browser/externalTerminal.contribution.js';
import './vscode/src/vs/workbench/contrib/terminal/browser/terminal.web.contribution.js';

class SimpleTerminalBackend {
    constructor() {
        this.getLatency = async () => [];
        this.isResponsive = true;
        this._whenConnected = new DeferredPromise();
        this.restartPtyHost = unsupported;
        this.remoteAuthority = undefined;
        this.onPtyHostUnresponsive = Event.None;
        this.onPtyHostResponsive = Event.None;
        this.onPtyHostRestart = Event.None;
        this.onDidRequestDetach = Event.None;
        this.attachToProcess = unsupported;
        this.attachToRevivedProcess = unsupported;
        this.listProcesses = unsupported;
        this.getProfiles = async () => [];
        this.getWslPath = unsupported;
        this.getEnvironment = async () => ({});
        this.getShellEnvironment = async () => undefined;
        this.setTerminalLayoutInfo = async () => { };
        this.updateTitle = async () => { };
        this.updateIcon = async () => { };
        this.getTerminalLayoutInfo = async () => undefined;
        this.reduceConnectionGraceTime = unsupported;
        this.requestDetachInstance = unsupported;
        this.acceptDetachInstanceReply = unsupported;
        this.persistTerminalState = unsupported;
    }
    get whenReady() { return this._whenConnected.p; }
    setReady() {
        void this._whenConnected.complete();
    }
    async getPerformanceMarks() {
        return [];
    }
}
class SimpleTerminalProcess {
    constructor(id, pid, cwd, onData) {
        this.id = id;
        this.pid = pid;
        this.cwd = cwd;
        this.onData = onData;
        this.onReady = new Emitter();
        this.shouldPersist = false;
        this.onProcessData = this.onData;
        this.onProcessReady = this.onReady.event;
        this.onDidChangeProperty = Event.None;
        this.onProcessExit = Event.None;
        this.processBinary = unsupported;
        this.refreshProperty = async () => undefined;
        setTimeout(() => {
            this.onReady.fire({
                cwd,
                pid,
                windowsPty: undefined
            });
        });
    }
    acknowledgeDataEvent() {
    }
    async setUnicodeVersion() {
    }
    async getInitialCwd() {
        return this.cwd;
    }
    async getCwd() {
        return this.cwd;
    }
    async getLatency() {
        return 0;
    }
    async updateProperty() {
    }
}
function getServiceOverride(backend) {
    if (backend != null) {
        ( Registry.as(TerminalExtensions.Backend)).registerTerminalBackend(backend);
    }
    return {
        [( ITerminalService.toString())]: new SyncDescriptor(TerminalService, [], true),
        [( ITerminalLogService.toString())]: new SyncDescriptor(TerminalLogService, [], true),
        [( ITerminalEditorService.toString())]: new SyncDescriptor(TerminalEditorService, [], true),
        [( ITerminalGroupService.toString())]: new SyncDescriptor(TerminalGroupService, [], true),
        [( ITerminalInstanceService.toString())]: new SyncDescriptor(TerminalInstanceService, [], true),
        [( ITerminalProfileService.toString())]: new SyncDescriptor(TerminalProfileService, [], true),
        [( ITerminalContributionService.toString())]: new SyncDescriptor(TerminalContributionService, [], true),
        [( ITerminalLinkProviderService.toString())]: new SyncDescriptor(TerminalLinkProviderService, [], true),
        [( ITerminalProfileResolverService.toString())]: new SyncDescriptor(ElectronTerminalProfileResolverService, [], true),
        [( IEnvironmentVariableService.toString())]: new SyncDescriptor(EnvironmentVariableService, [], true),
        [( ITerminalQuickFixService.toString())]: new SyncDescriptor(TerminalQuickFixService, [], true),
        [( IEmbedderTerminalService.toString())]: new SyncDescriptor(EmbedderTerminalService, [], true),
        [( ITerminalConfigurationService.toString())]: new SyncDescriptor(TerminalConfigurationService, [], true)
    };
}

export { SimpleTerminalBackend, SimpleTerminalProcess, getServiceOverride as default };
